// import Cookies from 'js-cookie'; // Artık kullanmıyoruz
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Grid';
import MuiLink from '@mui/material/Link';
import FacebookIcon from '@mui/icons-material/Facebook';
import GitHubIcon from '@mui/icons-material/GitHub';
import GoogleIcon from '@mui/icons-material/Google';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import BasicLayout from 'layouts/authentication/components/BasicLayout';
import bgImage from 'assets/images/bg-sign-in-basic.jpeg';
// import { Token, Aaro } from 'aaro'; // Artık kullanmıyoruz
import { login } from 'services/api/user';
// import { refreshGoogleToken } from 'services/api/user'; // Artık kullanmıyoruz
// import { UserContext } from 'App'; // Artık kullanmıyoruz
import { config } from 'Constants';
import axios from 'axios';

function Basic() {
    let navigate = useNavigate();
    // let location = useLocation(); // Artık kullanmıyoruz
    // let from = location.state?.from?.pathname || '/'; // Artık kullanmıyoruz
    const [rememberMe, setRememberMe] = useState(false);
    const handleSetRememberMe = () => setRememberMe(!rememberMe);
    // const { user, setUser } = useContext(UserContext); // Artık kullanmıyoruz
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [disabled, setDisabled] = useState(false);
    // const [error, setError] = useState(''); // Artık kullanmıyoruz

    useEffect(() => {
        localStorage.clear();
    }, []);

    const tryLogin = async () => {
        const info = {
            username: userName.replace('@kahramanlar.com.tr', ''),
            password: password,
        };
        setDisabled(true);
        let resp;
        try {
            resp = await login(info);
        } catch {
            alert('Hatalı giriş');
            setPassword('');
            setDisabled(false);
            return;
        }

        // Aaro token mantığı değişti - artık profilde kaydedilen token kullanılıyor
        // Login sırasında şifre ile token almayı kaldırdık
        console.log('Login successful, Aaro token will be used from user profile if available');

        // Eğer kullanıcıda zaten kaydedilmiş aaroToken varsa onu koru
        const existingAaroToken = resp.data.aaroToken || null;
        resp.data.aaroToken = existingAaroToken;

        localStorage.clear();
        localStorage.setItem('user', JSON.stringify(resp.data));

        // Aaro kullanıcı adı ve şifre cookie'leri artık gerekmiyor
        // çünkü onetime token sistemi kullanıyoruz
        // Cookies.set('aaroUser', addKahramanlar(userName), {
        //     expires: 7,
        //     domain: config.url.DOMAIN,
        // });
        // Cookies.set('aaroPass', password, {
        //     expires: 7,
        //     domain: config.url.DOMAIN,
        // });

        // Google token kontrolü yap, başarısız olsa bile devam et
        if (resp.data.googleAuth?.refreshToken) {
            const expiryDate = new Date(resp.data.googleAuth.expiryDate);
            const now = new Date();

            if (now >= expiryDate) {
                try {
                    const refreshResponse = await axios.post(
                        `${config.url.API_URL}/api/users/auth/google/refresh`,
                        null,
                        {
                            headers: {
                                Authorization: resp.data.token,
                            },
                        }
                    );

                    if (refreshResponse.data.success) {
                        const updatedUser = {
                            ...resp.data,
                            googleAuth: refreshResponse.data.result,
                        };
                        localStorage.setItem('user', JSON.stringify(updatedUser));
                    }
                } catch (err) {
                    console.error('Google token refresh failed:', err);
                    // Google token yenileme başarısız olsa bile devam et
                }
            }
        }

        // Başarılı login sonrası yönlendirme
        // setUser({ loggedIn: true, username: userName, password }); // UserContext artık kullanılmıyor
        // Direct navigation yapalım
        navigate('/dashboards/analytics');
    };

    async function handleSubmit(event) {
        event.preventDefault();
        await tryLogin();
    }

    return (
        <BasicLayout image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    mx={2}
                    mt={-3}
                    p={2}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Kahramanlar A.Ş.
                    </MDTypography>
                    <Grid
                        container
                        spacing={3}
                        sx={{
                            justifyContent: 'center',
                            mt: 1,
                            mb: 2,
                        }}
                    >
                        <Grid size={2}>
                            <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                                <FacebookIcon color="inherit" />
                            </MDTypography>
                        </Grid>
                        <Grid size={2}>
                            <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                                <GitHubIcon color="inherit" />
                            </MDTypography>
                        </Grid>
                        <Grid size={2}>
                            <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                                <GoogleIcon color="inherit" />
                            </MDTypography>
                        </Grid>
                    </Grid>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form" onSubmit={handleSubmit}>
                        <MDBox mb={2}>
                            <MDInput
                                type="text"
                                label="Kullanıcı Adı"
                                fullWidth
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                                required={true}
                            />
                        </MDBox>
                        <MDBox mb={2}>
                            <MDInput
                                type="password"
                                label="Şifre"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required={true}
                                fullWidth
                            />
                        </MDBox>
                        <MDBox display="flex" alignItems="center" ml={-1}>
                            <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                            <MDTypography
                                variant="button"
                                fontWeight="regular"
                                color="text"
                                onClick={handleSetRememberMe}
                                sx={{
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                    ml: -1,
                                }}
                            >
                                &nbsp;&nbsp;Beni Hatırla
                            </MDTypography>
                        </MDBox>
                        <MDBox mt={4} mb={1}>
                            <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={disabled}>
                                GİRİŞ
                            </MDButton>
                        </MDBox>
                        <MDBox mt={3} mb={1} textAlign="center">
                            <MDTypography variant="button" color="text">
                                <MDTypography
                                    component={Link}
                                    to="#"
                                    variant="button"
                                    color="info"
                                    fontWeight="medium"
                                    textGradient
                                >
                                    AARO
                                </MDTypography>{' '}
                                hesabınız ile giriş yapmalısınız.
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </BasicLayout>
    );
}

// Artık kullanılmıyor - onetime token sistemi ile gerekmiyor
// const addKahramanlar = (username) => {
//     if (!username.includes('@')) {
//         return username + '@kahramanlar.com.tr';
//     }
//     return username;
// };

export default Basic;
